{
  "ts": 1745310651,
  "tsCommit": 1745310616,
  "repoName": "WebSignup",
  "branchName": "prod",
  "rev": "9066206",
  "ver": "20250422_0830_WebSignup_prod_9066206",
  "env": "production"
}
